/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getConversations({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.get("/conversations", { headers, params, signal });
}

export function createConversation({ payload }) {
  const currentUser = store.getters['user/currentUser']
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
    "x-operator-id": currentUser.user_id,
  };
  return axios.post("/conversations", payload, { headers });
}

export function getConversation({ conversationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.get(`/conversations/${conversationId}`, { headers, signal });
}

export function updateConversation({ conversationId, payload, params }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}`, payload, { headers, params });
}

export function deleteConversation({ conversationId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.delete(`/conversations/${conversationId}`, { headers });
}

export function getMessagesForConversation({ conversationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/conversations/${conversationId}/messages`, { headers, signal });
}

export function createMessageReplyOnConversation({ conversationId, payload, params }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}/messages`, payload, { headers, params });
}

export function closeConversation({ conversationId, payload, params }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.post(`/conversations/${conversationId}/close`, payload, { headers, params });
}

export function assignAgentToConversation({ conversationId, userId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}/assign/${userId}`, {}, { headers });
}

export function unassignAgentFromConversation({ conversationId, userId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.delete(`/conversations/${conversationId}/assign/${userId}`, { headers });
}

export function getConversationRecipients({ conversationId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.get(`/conversations/${conversationId}/recipients`, { headers, signal });
}

export function addRecipientToConversation({ conversationId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.put(`/conversations/${conversationId}/recipients`, payload, { headers });
}

export function removeRecipientFromConversation({ conversationId, recipientId }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };
  return axios.delete(`/conversations/${conversationId}/recipients/${recipientId}`, { headers });
}
